import React from 'react';
import { useSelector } from 'react-redux';
import { MembershipBanner } from '@noths/polaris-client-ribbons-design-system';

import type { ReduxApplicationState } from 'src/redux/types';
import { trackCTAClick } from 'src/tracking/trackCTAClick';
import { trackImpression } from 'src/tracking/trackImpression';

export const MembershipBannerSection = () => {
  const content = useSelector((state: ReduxApplicationState) => state.content.membershipBanner);

  if (!content) {
    return null;
  }

  const commonTrackingArgs = {
    category: 'Membership banner',
    contentType: `membership banner|${content.trackingTitle}`,
    label: content.trackingTitle,
  };

  return (
    <MembershipBanner
      backgroundImageUrl={content.backgroundImageURL}
      buttonHref={content.link.href}
      buttonText={content.link.text}
      copy={content.copy}
      heading={content.heading}
      onButtonClick={(e) => trackCTAClick(e, commonTrackingArgs)}
      onVisible={() => trackImpression(commonTrackingArgs)}
    />
  );
};
